export default __webpack_public_path__ + "static/media/present.bea614f3.webp";